import { ViewportScroller } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { isNotNullable, isNotUndefined, LanguageService, OccEndpointsService } from '@spartacus/core';
import { Observable, of, Subscription } from 'rxjs';
import { CookieService } from 'src/app/customServices/cookie.service';
import { KbReturnRequestForm } from '../kb-returnRequest.service';
import { KbReturnRequestFileService } from '../kb-returnRequestFile.service';
import { switchMap, shareReplay, filter, delay } from 'rxjs/operators';
import { ReturnRequestFileUploadComponent } from '../return-request-file-upload/return-request-file-upload.component';

@Component({
  selector: 'app-kbreturnrequestform',
  templateUrl: './kbreturnrequestform.component.html',
  styleUrls: ['./kbreturnrequestform.component.scss'],
  standalone: false
})
export class KbreturnrequestformComponent {
  showCustomerList = false;
  userDetails$: any;
  warrantyData$!: Observable<any>;
  selectedCustomerId: any;
  isReviewed = false;
  isUploadAble: boolean[] = [true];
  isFormContainsError: boolean = false;
  isFormFilledSuccessfully: boolean = false;
  submittedSuccessFully: any;
  productNotFound: string[] = [undefined];
  baseUrl: string = '';
  partNumber = '';
  fileList$: any = of([0]);
  subscription = new Subscription();


  warrantyClaimApplication = new FormGroup({
    soldTo: new FormControl(null),
    date: new FormControl(''),
    returnRequestNumber: new FormControl(''),
    partsDisposition: new FormControl(''),
    PONumber: new FormControl('', { validators: Validators.required }),
    email: new FormControl('', { validators: Validators.email }),
    phoneNumber: new FormControl(''),
    partInfoDataList: this.fb.array([]),
  });

  partInformationNumberForm() {
    return new FormGroup({
      customerPartNumber: new FormControl(''),
      entryNumber: new FormControl(''),
      partNumber: new FormControl('', { validators: Validators.required }),
      quantity: new FormControl('', { validators: Validators.required }),
      natureOfDefect: new FormControl('', { validators: Validators.required }),
      typeNo: new FormControl(''),
      description: new FormControl(''),
      returnRequestType: new FormControl(null, { validators: Validators.required }),
    });
  }

  get warrantyClaimForm() {
    return this.warrantyClaimApplication.controls;
  }

  get partInfoDataList(): FormArray {
    return this.warrantyClaimApplication.get('partInfoDataList') as FormArray;
  }

  getPartInfoControl(index: number, controlName: string): any {
    return this.warrantyClaimApplication.get('partInfoDataList').get(index.toString()).get(controlName);
  }

  @HostListener('keydown.escape')
  @HostListener('document:click')
  onDocumentClick() {
    this.showCustomerList = false;
  }

  selectedCustomerUnit(event) {
    this.showCustomerList = false;
    this.selectedCustomerId = event;
  }

  showSearchResults($event: Event) {
    $event.stopPropagation();
    this.showCustomerList = !this.showCustomerList;
  }

  constructor(
    private kbWarrantyService: KbReturnRequestForm,
    private fb: FormBuilder,
    private cookieService: CookieService,
    private dialog: MatDialog,
    private fileService: KbReturnRequestFileService,
    private cdr: ChangeDetectorRef,
    private scroller: ViewportScroller,
    private endPointService: OccEndpointsService,
    private languageService: LanguageService
  ) {
    this.partInfoDataList.push(this.partInformationNumberForm());
    this.baseUrl = this.endPointService.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  ngOnInit() {
    this.warrantyData$ = this.languageService.getActive().pipe(
      switchMap(() => {
        return this.kbWarrantyService.getSubmitWarranty();
      }),
      shareReplay(1)
    );
    this.getWarrantyData();
  }

  getWarrantyData() {
    this.subscription.add(
      this.warrantyData$.pipe(filter(isNotUndefined && isNotNullable), delay(500)).subscribe((data) => {
        const customerId = this.cookieService.getCookieValue('customerIdNA');
        this.selectedCustomerId = data.b2bUnitsWSList.find((item) => item.uid === customerId);
        this.warrantyClaimApplication.patchValue({
          soldTo: this.selectedCustomerId?.uid,
          date: data?.claimSubmitDate,
          email: data?.customer?.displayUid,
        });
        this.cdr.detectChanges();
      })
    );
  }

  isEligibleForReturn(event, i: number) {
    const partNo = event.target.value.trim();
    this.productNotFound[i] = undefined;
    this.partInfoDataList.value.find((controls, index) => {
      if ((index !== i) && (controls.partNumber === partNo)) {
        this.productNotFound[i] = 'Product Already Exists';
      }
    });
    if (this.productNotFound[i] == 'Product Already Exists') {
      return;
    }
    this.subscription.add(this.kbWarrantyService.getProductForCustomPart(partNo + ',' + this.warrantyClaimForm.soldTo.value).subscribe((res: any) => {
      if (res.productData) {
        this.getPartInfoControl(i, 'typeNo').setValue(res.productData.typenumber);
        this.getPartInfoControl(i, 'description').setValue(res.productData.description);
        this.getPartInfoControl(i, 'entryNumber').setValue(i);
        this.getPartInfoControl(i, 'customerPartNumber').setValue(partNo);
        this.isUploadAble[i] = false;
        this.partNumber = event.target.value;
        this.fileService.addFile(null, this.partNumber, i);
      } else {
        this.getPartInfoControl(i, 'entryNumber').setValue(i);
        this.getPartInfoControl(i, 'customerPartNumber').reset();
        this.getPartInfoControl(i, 'partNumber').reset();

        this.productNotFound[i] = res?.errorMsg;
        this.isUploadAble[i] = true;
      }
      this.cdr.detectChanges();
    }));
  }

  addPartNumber() {
    this.isUploadAble.push(true);
    this.partInfoDataList.push(this.partInformationNumberForm());
  }

  removePartInfo(i) {
    this.partInfoDataList.removeAt(i);
  }

  submitReviewWarrantyClaim() {
    if (this.warrantyClaimApplication.valid) {
      this.isFormContainsError = false;
      this.subscription.add(this.kbWarrantyService.submitWarrantyForReview(this.warrantyClaimApplication.value).subscribe((res: any) => {
        this.isReviewed = true;
        this.isFormFilledSuccessfully = true;
        this.scroller.scrollToPosition([0, 150]);
        this.cdr.detectChanges();
      }));
    } else {
      this.isFormContainsError = true;
      this.scroller.scrollToPosition([0, 150]);
      this.warrantyClaimApplication.markAllAsTouched();
      this.cdr.detectChanges();
    }
  }

  submitWarrantyClaim() {
    if (!this.warrantyClaimApplication.valid) {
      return;
    }
    const fileList = this.fileService.filesMapSubject.getValue();
    const data: any = this.warrantyClaimApplication.getRawValue();
    data.partInfoDataList.forEach((part, index) => {
      const partNumber = part.partNumber;
      const attachmentInfo = [];
      const key = `${partNumber}/${index}`;
      const files = fileList[key];
      if (Array.isArray(files)) {
        files.forEach((file) => {
          attachmentInfo.push({
            fileName: file.name,
            fileSize: file.size,
          });
        });
      }
      part.attachmentsInfo = attachmentInfo;

    });
    this.isFormContainsError = false;
    this.subscription.add(this.kbWarrantyService.finalSubmitWarranty(data).subscribe((res: any) => {
      if (res) {
        this.isFormFilledSuccessfully = false;
        this.submittedSuccessFully = res;
        this.scroller.scrollToPosition([0, 150]);
        this.warrantyClaimForm.returnRequestNumber.patchValue(res?.claimNumber);
        this.warrantyClaimApplication.disable();
        this.cdr.detectChanges();
        this.fileService.uploadTheFilesOnebyOne(res?.claimNumber);
      }
    }));
  }

  uploadFile(index: number) {
    const PartNumber = this.getPartInfoControl(index, 'partNumber').value;
    const id = PartNumber + '/' + index;
    const dialogRef = this.dialog.open(ReturnRequestFileUploadComponent, {
      data: {
        id: id,
        index: index,
      },
    });
    this.subscription.add(dialogRef.afterClosed().subscribe(() => {
      this.fileList$ = this.fileService.filesMap$;
      this.cdr.detectChanges();
    }));
  }

  ngOnDestroy() {
    this.fileService.clearAllFiles();
    this.subscription.unsubscribe();
  }
}
